/**
 * Quiet BackHandler for the web bundle.
 *
 * ~30 screens call `BackHandler.addEventListener('hardwareBackPress', ...)` to
 * handle the Android hardware back button. react-native-web's BackHandler is
 * already a no-op, but it logs `console.error("BackHandler is not supported on
 * web...")` on every single registration, which floods the console and buries
 * real errors.
 *
 * A desktop browser has no hardware back button, so a no-op is the correct
 * behaviour - this shim keeps it and drops only the noise, with one debug line
 * so the situation stays discoverable. Browser Back/Forward is handled by
 * React Navigation's linking config (src/platform/navigation/linking.web.ts).
 *
 * The Android BackHandler is untouched: this file only ever enters the web
 * bundle, via resolve.alias in webpack.config.js.
 */

type BackHandlerSubscription = {remove: () => void};

const noop = () => {};

let warned = false;

const BackHandler = {
  exitApp: noop,

  addEventListener(_eventName: string, _handler: () => boolean): BackHandlerSubscription {
    if (!warned) {
      warned = true;
      console.debug(
        '[ZenBasket POS] hardwareBackPress handlers are inert on web; use the browser Back button.',
      );
    }
    return {remove: noop};
  },

  removeEventListener: noop,
};

export default BackHandler;
